<template>
  <div class="dropdown-list">
    <slot />

    <div
      v-for="value in values"
      :key="value.id"
      :class="{
        'dropdown-list__item': true,
        'dropdown-list__item_active': checkValueIsActive(value)
      }"
      @click="selectItem(value)"
    >
      {{ value.name }}
      <span
        v-if="value.description"
        class="dropdown-list__description"
      >{{ value.description }}</span>
    </div>

    <div
      v-if="!values.length"
      class="dropdown-list__nodata"
    >
      {{ $t('form.DropdownList.empty') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { SelectValueItem } from '~/types/components/form';

const props = defineProps<{
  modelValue: number | string | null,
  values: SelectValueItem[],
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void,
  (e: 'select', value: SelectValueItem): void,
}>();

function selectItem(value: SelectValueItem) {
  emit('update:modelValue', value.name);
  emit('select', value);
}

function checkValueIsActive(value: SelectValueItem) {
  return props.modelValue === value.id;
}
</script>

<style scoped lang="scss">
.dropdown-list {
  position: absolute;
  width: 100%;
  left: 0;
  top: 100%;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  overflow: auto;
  max-height: 250px;
  border-radius: 0 0 2px 2px;

  &__item {
    padding: 7px 12px 8px;
    font-size: 14px;
    color: #202020;
    transition: all 0.3s;
    background: transparent;
    cursor: pointer;

    &:hover,
    &_active {
      background: #e6e6e6;
    }
  }

  &__description {
    margin-left: 7px;
    color: #bdbdbd;
  }

  &__nodata {
    padding: 7px 12px 15px;
    text-align: center;
  }
}
</style>
